import React, { useState, useRef, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import SelectList from '../UI/Control/SelectList';
import Button from '../UI/Button/Button';
import Card from '../UI/Card/Card';
import InputString from '../UI/Control/InputString';
import NoData from '../NoData';
import classes from './../TrialstatNoto.module.css';
import ZeltaStudyModal from "./ZeltaStudyModal";
import DeleteIcon from '../../Images/Icons/delete.svg';

const ZeltaStudyList = (props) => {
    const EDCUserID = useSelector(state => state.auth.gValue01);
    const [rowData, setData] = useState([]);
    const [userPermission, setUserPermisssion] = useState('RO'); //RO, RW, NA
    const [sponsorsList, setSponsorsList] = useState([{}]);
    const [sponsorId, setSponsorId] = useState(-1);

    const onClickRefershHandler = () => {
        setQ('');
        setInputVal('');
        setSponsorId(-1);
        fetchData();
        sessionStorage.setItem('searchedZeltaStudyVal', '');
    }
    useEffect(() => {
        fetchData();
        getUserRole();
        fetchSponsorsList();
    }, [])

    const getUserRole = () => {
        fetch('api/ZeltaStudy/GetRoleByID?userID=' + EDCUserID)
            .then(response => response.text())
            .then(role => {
                setCompPermission(role);
            });
    };

    const fetchSponsorsList = () => {
        fetch('api/ZeltaStudy/GetSponsors')
            .then(response => response.json())
            .then(data => {
                setSponsorsList(data);
            });
    }
    
    const setCompPermission = (role) => {
        if (role == "Read-Only")
            setUserPermisssion("RO")
        else if (role == "Database Designer" || role == "Super User")
            setUserPermisssion("RW")
        else if (role == "Tester")
            setUserPermisssion("RO")
        else if (role == "Clinical Data Manager" || role == "Manager, Clinical Data Management" || role == "Clinical Project Manager") {
            setUserPermisssion("RO")
        }
        else
            setUserPermisssion("NA")
    }

    const [q, setQ] = useState('');
    const [inputVal, setInputVal] = useState('');

    const columns = [
        {
            name: "Short Name",
            selector: row => row.StudyCode,
            cellExport: row => row.StudyCode,
            sortable: true,
            center: true,
            cell: (row) => (
                <div className={classes.textWrap}>{row.StudyCode}</div>
            )
        },
        {
            name: "Study Name",
            selector: row => row.StudyName,
            cellExport: row => row.StudyName,
            sortable: true,
            center: true,
            cell: (row) => (
                <div className={classes.textWrap}>{row.StudyName}</div>
            )
        },
        {
            name: "Sponsor",
            selector: row => row.Sponsor,
            cellExport: row => row.Sponsor,
            sortable: true,
            center: true,
        },
        {
            name: "Creation By",
            selector: row => row.UserName,
            cellExport: row => row.UserName,
            sortable: true,
            center: true,
        },
        {
            name: "Creation Date",
            selector: row => row.CreationDate,
            cellExport: row => row.CreationDate,
            sortable: true,
            center: true,
        },
        {
            name: "Action",
            button: true,
            className: 'headercaption',
            width: userPermission == "RW" ? '550px' : '0px',
            style: {
                'border-right-style': 'solid',
                'border-width': '1px',
                'border-color': 'rgba(0, 0, 0, 0.12)'
            },
            cell: (row) => (
                <div style={{ "padding": "5px" }}>
                    {userPermission == "RW" && <img style={{ "border": "1px solid #dcdcdc", "cursor": "pointer", marginLeft: "5px", "float": "right" }}
                        height="34px" width="34px" src={DeleteIcon} alt="Delete" title="Delete Study" onClick={e => handleDeleteZeltaStudy(row.StudyID, e)} />}
                    {userPermission == "RW" && <ZeltaStudyModal btn="icon" action="edit" header="Update Study" studyId={row.StudyID} studyName={row.StudyCode} fetchData={fetchData}></ZeltaStudyModal>}
                    {userPermission == "RW" && <ZeltaStudyModal btn="icon" action="view" header="View Study" studyId={row.StudyID} studyName={row.StudyCode}></ZeltaStudyModal>}
                </div>
            )
        }
    ];


    const fetchData = () => {
        fetch('api/ZeltaStudy/GetZeltaStudyDataList').then(response => response.json())
            .then(data => {
                setData(data);
                if (sessionStorage.getItem('searchedZeltaStudyVal') != '' && sessionStorage.getItem('searchedZeltaStudyVal') != null) {

                    let objSerachedVal = JSON.parse(sessionStorage.getItem('searchedZeltaStudyVal'));
                    if (objSerachedVal != null) {
                        setQ(objSerachedVal.searchText);

                        if ((objSerachedVal.filterSponsor != -1 || objSerachedVal.filterSponsor == null) && objSerachedVal.searchText == '') {
                            setSponsorId(objSerachedVal.filterSponsor);
                            setQ(objSerachedVal.sponsorText);
                            setInputVal('');
                        }
                        else if ((objSerachedVal.filterSponsor != -1 || objSerachedVal.filterSponsor == null) && objSerachedVal.searchText != '') {
                            setQ(objSerachedVal.searchText);
                            setInputVal(objSerachedVal.searchText);
                        }
                        sessionStorage.setItem('searchedZeltaStudyVal', JSON.stringify({ filterSponsor: objSerachedVal.filterSponsor, sponsorText: objSerachedVal.sponsorText, searchText: objSerachedVal.searchText }));
                    }
                }
            });
    }

    function search(rows) {
        var filteredColumns = [];
        if (q != '') {
            filteredColumns = ['StudyName', 'StudyCode', 'Sponsor', 'UserName','CreationDate'];

            let selString = q.toString();
            let searchText = selString.toLowerCase().split(",");
            return rows.filter((row) => {
                return filteredColumns.some((column) => {
                    if (searchText.length > 1)
                        return searchText.indexOf(row[column].toString().toLowerCase()) > -1
                    else
                        return row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
                })
            })
        }
        else
            return rows;
    }
    const searchChangeHandler = (e) => {
        setQ(e.target.value);
        setInputVal(e.target.value);
        if (search(rowData).length == 1) {
            const collection = document.getElementsByClassName("rdt_Table");
            collection[0].setAttribute("style", "min-height: 200px!important");
        }
        setSponsorId(-1);
        sessionStorage.setItem('searchedZeltaStudyVal', JSON.stringify({ filterSponsor: null, sponsorText: null, searchText: document.getElementById('txtSearch').value }));
    }

    const handleDeleteZeltaStudy = (studyId, event) => {
        var con = confirm('Are you sure, you want to delete study?');
        if (con == true) {
            DeleteZeltaStudy(studyId);
        }
    };

    const DeleteZeltaStudy = (studyId) => {
        let objStudyModel = {
            StudyID: studyId,
            UserName: EDCUserID,
            Alert: 'X'
        };

        fetch('api/ZeltaStudy/DeleteZeltaStudy', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(objStudyModel)
        }).then(r => r.json()).then(res => {
            if (res > 0) {
                fetchData();
            }
        })
    };

    var FilterSponsorHandler = (e) => {
        setSponsorId(document.getElementById("ddlSponsors").value);
        let selVal = e.target.value == '-1' ? '' : e.target.value;
        var selDdl = document.getElementById("ddlSponsors");
        let selTxt = e.target.value == '-1' ? '' : selDdl.options[selDdl.selectedIndex].text;

        setQ(selTxt);
        setInputVal('');
        sessionStorage.setItem('searchedZeltaStudyVal', JSON.stringify({ filterSponsor: selVal, sponsorText: selTxt, searchText: ''}));
    };

    return <Card>
        <Row>
            <Col md={3} className="form-inline mb-2">
                <SelectList dataSource={sponsorsList} id="ddlSponsors" onChangeHandler={FilterSponsorHandler} value={sponsorId} />
            </Col>
            <Col md={1} style={{ paddingRight: "0px", width: "3%" }}>
            </Col>
            <Col md={2}>
            </Col>
            <Col md={3}>
                <InputString id="txtSearch" value={inputVal} onChangeHandler={searchChangeHandler} placeholder="Search" style={{ marginRight: "15px" }} />
            </Col>
            <Col md={1} style={{ paddingLeft: "0px" }}>
                <Button onClick={onClickRefershHandler} className="btn btn-success">Refresh</Button>
            </Col>
            <Col md={2}>
                {userPermission == "RW" && <ZeltaStudyModal text="Create new study" btn="true" action="add" header="Create Study" studyId="" studyName="" style={{ float: "right" }} fetchData={fetchData} />}
            </Col>
        </Row>
        <div className="tableContainer">
            {search(rowData).length > 0 ? <DataTable
                columns={columns}
                data={search(rowData)}
                className="table table-striped table-bordered table-hover"
                striped
                pagination
                paginationPerPage={50}
                paginationRowsPerPageOptions={[20, 50, 100]}
            /> : <NoData headers={columns}></NoData>}
        </div>
    </Card>
}
export default ZeltaStudyList;